const IssuerPayment = {
  state: {
    approved: "approved",
    approved_by_timeout: "approved_by_timeout",
    exchange: "exchange",
    inactive: "inactive",
    issuer_approved: "issuer_approved",
    late_payment: "late_payment",
    paid: "paid",
    paid_by_collection_house: "paid_by_collection_house",
    pending_approve: "pending_approve",
    pending_new_amount_request: "pending_new_amount_request",
    pending_reject_request: "pending_reject_request",
    rejected: "rejected"
  },

  // Estados de issuer_payment (integers)
  // Basado en catálogo issuer_payment_state de la base de datos
  stateId: {
    PENDIENTE: 1, // Pago creado, sin transacción PSE
    APROBADO: 2, // Transacción aprobada por el banco
    POR_CONFIRMAR: 3, // Transacción en curso de ser validada por el banco
    RECHAZADO: 4, // Transacción rechazada por el banco
    NOTIFICADO: 5, // Pago notificado al ACC
    ACREDITADO: 6, // Pago acreditado al balance de los inversionistas
    BLOQUEADO: 7 // Pago bloqueado manualmente
  },

  // Tipos de pago (integers)
  // Basado en catálogo issuer_payment_type
  typeId: {
    ABONO_CAPITAL: 1, // Abono directo al capital
    PAGO_TOTAL_DEUDA: 2, // Pago que cubre el total
    PAGO_CUOTA_ORDINARIA: 3, // ← AC01 (Pago de cuota programada)
    CUOTA_ABONO: 4, // Pago de cuota + abono adicional
    PAGO_TOTAL_MORA: 5, // ← AC02 (Pago que cubre toda la mora)
    PAGO_PARCIAL_MORA: 6, // Pago parcial a la mora
    PAGO_GARANTIA: 7 // Pago cubierto por garantía
  },

  // Estados de pyme_payment_campaign (integers)
  // Basado en catálogo pyme_payment_state
  pymePaymentStateId: {
    AL_DIA: 1, // Pago anticipado - Al día
    EN_FRANJA: 2, // Pendiente en periodo válido
    EN_MORA: 3 // Con mora
  },

  transactionType: {
    PAGO_PARCIAL_MORA: "partial_overdue_payment",
    PAGO_MORA: "due_overdue_payment"
  },

  // Helpers para mapear estados visuales
  /**
   * Obtiene el estado visual según issuer_payment_state_id
   * @param {number} issuerPaymentStateId - ID del estado (1-7)
   * @returns {Object} { label, color, icon }
   */
  getVisualState(issuerPaymentStateId) {
    const mapping = {
      1: { label: "Pendiente", color: "info", icon: "" },
      2: { label: "Aprobado", color: "success", icon: "" },
      3: { label: "Por confirmar", color: "warning", icon: "" },
      4: { label: "Rechazado", color: "error", icon: "" },
      5: { label: "Notificado", color: "info", icon: "" },
      6: { label: "Acreditado", color: "success", icon: "" },
      7: { label: "Bloqueado", color: "error", icon: "" }
    };
    return mapping[issuerPaymentStateId] || mapping[1];
  },

  /**
   * Obtiene el nombre del tipo de pago según issuer_payment_type_id
   * @param {number} typeId - ID del tipo (1-7)
   * @returns {string} Nombre del tipo de pago
   */
  getPaymentTypeName(typeId) {
    const mapping = {
      1: "Abono a capital",
      2: "Pago total deuda",
      3: "Pago cuota ordinaria",
      4: "Cuota + abono",
      5: "Pago total mora",
      6: "Pago parcial mora",
      7: "Pago garantía"
    };
    return mapping[typeId] || "Desconocido";
  },

  /**
   * Valida si el estado es aprobado (3, 4, 5, 6)
   * @param {number} stateId - ID del estado
   * @returns {boolean}
   */
  isApprovedState(stateId) {
    return [3, 4, 5, 6].includes(stateId);
  },

  /**
   * Valida si el estado es "Por confirmar" (1)
   * @param {number} stateId - ID del estado
   * @returns {boolean}
   */
  isPendingConfirmation(stateId) {
    return stateId === 1;
  },

  /**
   * Valida si el estado es "Rechazado" (2)
   * @param {number} stateId - ID del estado
   * @returns {boolean}
   */
  isRejected(stateId) {
    return stateId === 2;
  },

  /**
   * Valida si el tipo es "Pago cuota ordinaria" (3)
   * @param {number} typeId - ID del tipo
   * @returns {boolean}
   */
  isDuePaymentType(typeId) {
    return typeId === 3;
  },

  /**
   * Valida si el tipo es pago de mora (5 o 6)
   * @param {number} typeId - ID del tipo
   * @returns {boolean}
   */
  isOverduePaymentType(typeId) {
    return [5, 6].includes(typeId);
  }
};

export default IssuerPayment;
